import React from 'react'

import { Link } from 'gatsby'

import { wpButtonType } from '@contracts/acf/button'
import { CustomizableComponent } from '@contracts/components/customizableComponent'

import { usePageLinks } from '@hooks/usePageLinks'

import * as styles from './Button.module.scss'

interface Props extends CustomizableComponent {
	data: wpButtonType
	type?: 'default' | 'hollow'
	size?: 'default' | 'small'
	theme?: 'default' | 'white'
	children?: React.ReactNode
	disabled?: boolean
	onClick?: () => void
}

const Button: React.FunctionComponent<Props> = (props) => {
	const pageLinks = usePageLinks()
	const buttonStyles = [styles.button]

	if (props.className) {
		buttonStyles.push(props.className)
	}

	if (props.type == 'hollow') {
		buttonStyles.push(styles.hollow)
	}

	if (props.size == 'small') {
		buttonStyles.push(styles.small)
	}

	if (props.theme) {
		buttonStyles.push(styles[props.theme])
	}

	const isDisabled = props.disabled !== undefined ? props.disabled : false

	const link = props.data

	// Normal Buttons
	if (typeof link !== 'string') {
		if (link.buttonType == 'internal' && link.internalLink) {
			return (
				<Link to={link.internalLink.uri} className={buttonStyles.join(' ')}>
					{link.label}
				</Link>
			)
		}

		if (link.buttonType == 'external' && link.externalLink) {
			return (
				<a href={link.externalLink} className={buttonStyles.join(' ')}>
					{link.label}
				</a>
			)
		}
	}

	// Click handler
	if (link === 'click' && props.onClick !== undefined) {
		const localClickHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, customFunc: () => void) => {
			e.preventDefault()

			customFunc()
		}

		return (
			<button
				className={buttonStyles.join(' ')}
				// @ts-ignore
				onClick={(e) => localClickHandler(e, props.onClick)}
				disabled={isDisabled}
			>
				{props.children}
			</button>
		)
	}

	// Ref scroll handler
	if (link === 'ref') {
		return (
			<button className={buttonStyles.join(' ')} disabled={isDisabled}>
				{props.children}
			</button>
		)
	}

	// Static Buttons
	if (typeof link == 'string' && link !== 'click') {
		return (
			<Link to={pageLinks[link].link} className={buttonStyles.join(' ')}>
				{props.children}
			</Link>
		)
	}

	return null
}

Button.defaultProps = {
	type: 'default',
}

export default Button
